import React, { useState, createContext, useContext, ReactNode } from 'react';
// Shared audit-event shape — matches the rows the Operations Activity Log renders
// (mock rows, note events, and task events all use this shape).
export interface AuditEvent {
  id: string;
  timestamp: string;
  eventType: string;
  activity: string;
  entity: string | null;
  entityType: string | null;
  source: string;
  user: string;
  status: string;
  ipAddress: string | null;
  changes: {
    field: string;
    before: string;
    after: string;
  }[];
}
// Callers supply eventType + activity and whatever else is relevant; the provider
// fills sensible defaults (id, timestamp, source, user, status).
type AuditEventInput = Partial<AuditEvent> & {
  eventType: string;
  activity: string;
};
interface LoyaltyAuditContextType {
  auditEvents: AuditEvent[];
  addAuditEvent: (event: AuditEventInput) => void;
}
const LoyaltyAuditContext = createContext<LoyaltyAuditContextType | undefined>(undefined);
// Prototype has no auth, so staff-initiated actions are attributed to a fixed
// current user — same convention TaskContext already uses.
export const CURRENT_STAFF_USER = 'sarah.chen@acmewine.com';
export function LoyaltyAuditProvider({
  children
}: {
  children: ReactNode;
}) {
  const [auditEvents, setAuditEvents] = useState<AuditEvent[]>([]);
  const addAuditEvent = (event: AuditEventInput) => {
    const full: AuditEvent = {
      id: `audit-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      timestamp: new Date().toISOString(),
      entity: null,
      entityType: null,
      source: 'Admin Portal',
      user: CURRENT_STAFF_USER,
      status: 'Success',
      ipAddress: null,
      changes: [],
      ...event
    };
    setAuditEvents(prev => [full, ...prev]);
  };
  return <LoyaltyAuditContext.Provider value={{
    auditEvents,
    addAuditEvent
  }} data-id="element-6354" data-mp="2k14dxvmowhym">
      {children}
    </LoyaltyAuditContext.Provider>;
}
export function useLoyaltyAudit() {
  const context = useContext(LoyaltyAuditContext);
  if (!context) {
    throw new Error('useLoyaltyAudit must be used within a LoyaltyAuditProvider');
  }
  return context;
}